import store from "../store/index";
//---------------------------
// get combatant index by id
//---------------------------
export default function getCombatantIndexById(id) {
  // console.log("----------------------------------");
  // console.log("IN getCombatantIndexById...");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  //---------------
  // get combatants
  //---------------
  let combatants = this_store.arena.arena_combatants;
  //---------
  // get idx
  //---------
  const idx = combatants.map((i) => i.id).indexOf(id);
  //---------
  // returns
  //---------
  return idx;
}
